export default {
  /* 半成品*/
  getParPreparedProductsList: {// 获取半成品列表
    url: '/api/getParPreparedProductsList',
    method: 'get'
  },
  getParPreparedProductsRecords: {// 获取半成品明细列表
    url: '/api/getParPreparedProductsRecords',
    method: 'get'
  },
  getParPreparedProductsRecordInfo: {
    url: '/api/getParPreparedProductsRecordInfo',
    method: 'get'
  },
  getParPreparedProduct: {
    url: '/api/getParPreparedProduct',
    method: 'get'
  },
  createParPreparedProducts: {// 添加半成品
    url: '/api/createParPreparedProducts',
    method: 'post'
  },
  deleteParPreparedProducts: { // 删除半成品
    url: '/api/deleteParPreparedProducts',
    method: 'delete'
  },
  deleteParPreparedProductsRecords: { // 删除半成品明细
    url: '/api/deleteParPreparedProductsRecords',
    method: 'delete'
  },
  updateParPreparedProducts: {
    url: '/api/updateParPreparedProducts',
    method: 'put'
  },
  updateParPreparedProductsRecord: { // 更新半成品记录
    url: '/api/updateParPreparedProductsRecord',
    method: 'put'
  }
}
